// The booking wizard's wording in Simplified Chinese (Mandarin); keys match en.ts. Machine-drafted,
// flagged for native review.
import type { en } from "./en";

export const zh = {
  // Page
  schedule_appointment: "预约",
  powered_by: "技术支持",

  // Patient type
  new_or_existing: "您是新患者还是老患者？",
  new_patient: "新患者",
  existing_patient: "老患者",
  first_time_visiting: "我是第一次来这家诊所",
  been_here_before: "我以前来过",

  // Appointment info
  what_type: "您要预约哪种服务？",
  no_types_available: "目前没有可在线预约的服务。",
  minutes: "%{count}分钟",
  additional_info: "您有什么问题或不适想要咨询？",
  describe_concern: "请描述您的问题...",

  // Provider
  pick_provider: "选择医生",
  loading_providers: "正在加载医生...",
  failed_load_providers: "无法加载医生，请重试。",
  any_provider: "不限",
  show_all_available: "显示所有可预约时间",
  no_availability: "无可预约时间",

  // Time
  pick_a_time: "选择时间",
  finding_times: "正在查找可预约时间...",
  no_times_for_date: "这一天没有可预约时间",
  slot_just_taken: "抱歉，该时间刚刚被预约。请选择其他时间。",
  jump_to_next: "跳到下一个可预约时间",
  morning: "上午",
  afternoon: "下午",
  cant_find_time: "找不到合适的时间？请致电诊所，我们会为您安排。",

  // Patient info
  your_information: "您的信息",
  first_name: "名",
  last_name: "姓",
  preferred_name: "希望的称呼",
  optional: "选填",
  date_of_birth: "出生日期",
  phone_number: "电话号码",
  required: "必填",
  invalid_phone: "请输入有效的10位电话号码",
  min_age: "患者必须年满5岁",
  future_date: "不能是将来的日期",
  referral_question: "您是如何知道我们的？",
  referral_prompt: "请选择",
  referral_detail_who: "是谁推荐您来的？",
  referral_detail_other: "请告诉我们您是如何知道我们的",
  referral_detail_optional: "详情（选填）",
  verification_disclaimer: "我们会向此号码发送验证码。",
  phone_verified: "电话号码已验证",
  verifying: "正在验证...",
  verify: "验证",
  invalid_code: "验证码无效，请重试。",
  sending: "正在发送...",
  resend_code: "重新发送验证码",
  email: "电子邮件",
  send_verification: "发送验证码",
  sending_code: "正在发送验证码...",

  // Insurance
  insurance_info: "保险信息",
  have_insurance: "您有保险吗？",
  insurance_changed: "自上次就诊以来，您的保险有变化吗？",
  no_insurance_change: "没有变化",
  yes: "是",
  no: "否",
  insurance_name: "保险公司名称",
  subscriber_name: "投保人姓名",
  subscriber_dob: "投保人出生日期",
  subscriber_id: "投保人编号",
  group_number: "团体编号",
  select_option: "请选择",
  card_photo_title: "保险卡照片",
  card_photo_hint: "请添加保险卡正反两面的照片，以便我们在您就诊前核实保障内容。",
  card_front: "保险卡正面",
  card_back: "保险卡背面",
  add_photo: "添加照片",
  uploading_photo: "正在上传照片...",
  remove_photo: "删除",
  card_upload_failed: "无法添加照片。请重试，或不加照片继续。",
  card_try_again: "重试",

  // Review
  review_appointment: "确认预约信息",
  appointment_details: "预约详情",
  type_label: "类型",
  provider: "医生",
  any_available: "任何可预约的医生",
  date_and_time: "日期和时间",
  notes: "备注",
  patient_information: "患者信息",
  name: "姓名",
  phone: "电话",
  insurance: "保险",
  subscriber: "投保人",
  subscriber_id_label: "投保人编号",
  group_hash: "团体编号",
  no_insurance: "无保险",
  card_photos: "保险卡照片",
  card_front_short: "正面",
  card_back_short: "背面",
  waitlist: "如有更早的时间，请通知我",
  consent_prefix: "预约即表示您同意我们的",
  terms: "服务条款",
  consent_and: "和",
  privacy: "隐私政策",
  consent_suffix: "。提供电话号码即表示您同意接收短信。可能会产生短信和数据费用。",
  scheduling: "正在预约...",
  schedule_appointment_btn: "预约",
  continue_to_payment: "继续付款",

  // Deposit
  deposit_title: "支付订金",
  deposit_explainer:
    "支付%{amount}订金即可确认此预约。订金将存入您的账户，用于抵扣治疗费用。如果您未按时就诊，订金将不予退还。",
  deposit_due: "订金",
  deposit_card_fee: "刷卡手续费",
  deposit_card_fee_notice: "信用卡付款包含%{percentage}%的手续费。借记卡不收取手续费。",
  deposit_total: "合计",
  deposit_loading: "正在加载安全付款...",
  deposit_paying: "处理中...",
  deposit_pay_and_book: "付款并预约",
  deposit_card_error: "无法支付订金。请检查银行卡后重试。",
  deposit_unavailable: "无法加载安全付款。请致电诊所。",
  deposit_needs_hold: "无法保留此时间。请重新选择时间。",
  deposit_processing: "您的付款仍在确认中。请勿再次付款 — 诊所将很快确认您的预约。",

  // Confirmation
  appointment_requested: "已收到您的预约请求！",
  confirm_message: "诊所审核后会向您发送确认通知。如需更多信息，我们的工作人员会与您联系。",
  date: "日期",
  time: "时间",
  add_to_google: "添加到Google日历",
  download_ics: "下载日历文件（.ics）",
  questions_call: "如有疑问，请致电：",

  // Errors
  network_error: "出现问题，请重试。",

  // Common
  back: "返回",
  continue: "继续",
  review: "确认",

  // Step labels
  step_appointment: "预约",
  step_provider: "医生",
  step_time: "时间",
  step_your_info: "您的信息",
  step_insurance: "保险",
} as const satisfies Record<keyof typeof en, string>;
